"use client";
import React, { SetStateAction, useState } from "react";

import Carousel from "react-material-ui-carousel";
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Stack,
  Alert,
  AlertTitle,
  Button,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Copyright from "../../components/copyright";
import { brandingColors } from "../../components/utils";

export default function Work(): JSX.Element {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1000px",
        color: brandingColors["grey-font"],
        margin: "0 auto",
      }}
    >
      {/* top */}
      <Box
        sx={{
          background: "white",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "0 2 48px 0",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { xs: "row", md: "row" },
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              padding: "10px 20px",
            }}
          >
            <a href="/">
              {" "}
              <img
                alt=""
                src="/assets/123skincare_new.png"
                height="75px"
                style={{ objectFit: "cover" }}
              />
            </a>
          </Box>
          <Box
            sx={{
              padding: "10px 20px",
              display: "flex",
              flexDirection: { xs: "row", md: "row" },
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                padding: "10px 0 10px 15px",
              }}
            >
              <a href="/about">About us</a>
            </Box>
            <Box
              sx={{
                padding: "10px 0 10px 15px",
              }}
            >
              <a href="/about#work-with-us">Work With us</a>
            </Box>
          </Box>
          {/* <Box
            sx={{
              padding: "10px 20px",
              display: "flex",
              flexDirection: { xs: "row", md: "row" },
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                padding: "10px 15px",
              }}
            >
              <img
                alt=""
                src="/assets/uk.png"
                width="18px"
                style={{ objectFit: "cover" }}
              />{" "}
            </Box>
            <Box
              sx={{
                padding: "10px 15px",
              }}
            >
              <Typography variant={"subtitle2"}>Eng</Typography>
            </Box>
            <Box
              sx={{
                padding: "10px 15px",
              }}
            >
              <img
                alt=""
                src="/assets/shopping_cart.svg"
                width="18px"
                style={{ objectFit: "cover" }}
              />{" "}
            </Box>
          </Box> */}
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "12px 0 12px 0",
        }}
      >
        <Box
          sx={{
            padding: "20px",
          }}
        >
          <Typography variant={"h4"}>Work with us</Typography>
        </Box>
      </Box>

      {/* centre */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "12px 24px 48px 24px",
        }}
      >
        <Box
          sx={{
            margin: "10px 12px",
            padding: "20px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: { xs: "row", md: "row" },
              justifyContent: "space-between",
              color: brandingColors["grey-font"],
            }}
          >
            <Box
              sx={{
                padding: "10px 20px",
                width: "50%",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "column", md: "column" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "20px 0",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/123skincare_new.png"
                    width="150px"
                    style={{ objectFit: "cover" }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: "20px 0",
                  }}
                >
                  <Typography variant={"subtitle2"}>
                    We are the first AI-powered beauty recommandation platform
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "row", md: "row" },
                    justifyContent: "flex-start",
                    color: brandingColors["grey-font"],
                  }}
                >
                  <a
                    href="https://www.tiktok.com/@123skincarepro"
                    target="_blank"
                  >
                    <img
                      alt=""
                      src="/assets/tiktok.svg"
                      width="18px"
                      style={{ objectFit: "cover", marginRight: "5px" }}
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/123skincare/"
                    target="_blank"
                  >
                    <img
                      alt=""
                      src="/assets/linkedin.svg"
                      width="18px"
                      style={{ objectFit: "cover", marginRight: "5px" }}
                    />
                  </a>
                  <a
                      href="https://www.instagram.com/123skincare.pro/"
                      target="_blank"
                    >
                      <img
                        alt=""
                        src="/assets/instagram-square.svg"
                        width="18px"
                        style={{ objectFit: "cover", marginRight: "5px" }}
                      />
                    </a>
                </Box>
                <Copyright />
              </Box>
            </Box>
            <Box
              sx={{
                padding: "10px 20px",
                width: "50%",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "column", md: "column" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "row", md: "row" },
                    justifyContent: "space-between",
                    color: brandingColors["grey-font"],
                  }}
                >
                  <Box
                    sx={{
                      padding: "10px 20%",
                      width: "100%",
                      borderRadius: "10px",
                    }}
                  >
                    <Box
                      sx={{
                        padding: "10px 0",
                      }}
                    >
                      <a href="/about">About us</a>
                    </Box>
                    <Box
                      sx={{
                        padding: "10px 0",
                      }}
                    >
                      <a href="/about#work-with-us">Work With us</a>
                    </Box>

                    <Box
                      sx={{
                        padding: "10px 0",
                      }}
                    >
                      <a href="/privacy">Privacy policy</a>
                    </Box>
                    <Box
                      sx={{
                        padding: "10px 0",
                      }}
                    >
                      <a href="/cookie">Cookies</a>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
